export function incompleteDeviceFilterQuery(deviceIds: Array<number | string>): string {
  return deviceIds.map((id) => `id:"${id}"`).join(" OR ");
}

export function incompleteDeviceFilterSearch(deviceIds: Array<number | string>): string {
  const params = new URLSearchParams();
  params.set("q", incompleteDeviceFilterQuery(deviceIds));
  return `?${params.toString()}`;
}
